import Vue from 'vue'
import { formatDate } from '@/utils/date'
import Math from '@/utils/math';

Vue.directive('moneyFormat', function (el, binding) {
    if (!binding.value) {
        el.innerHTML = '0.00';
        return false;
    }
    
    let num = typeof binding.value === 'object' ? binding.value.num : 2

    let value = typeof binding.value === 'object' ? binding.value.value : binding.value
    let noPad = typeof binding.value === 'object' ? Boolean(binding.value.noPad) : false
    
    let numberArr = (Number(value) * 1).toString().split('.')
    if (num === 'auto') {
        numberArr[0] = numberArr[0] * 1
    } else {
        numberArr[1] = numberArr[1] ? numberArr[1].slice(0, num) : ''
        let bits = num - numberArr[1].length
        if (bits !== 0 && !noPad) {
            for (let i = 0; i < bits; i++) {
                numberArr[1] += '0'
            }
        }
    }

    el.innerHTML = numberArr[0] + (numberArr[1] ? '.' + numberArr[1] : '')
})

Vue.directive('dateFormat', function (el, binding, vnode) {
    let { second, format = 'yyyy-MM-dd hh:mm:ss' } = binding.value

    if (typeof binding.value !== 'object') {
        second = binding.value
    }
    if (second) {
        el.innerHTML = formatDate(second, format);
        el.title = el.innerHTML;
    }
})

Vue.directive('checkProductionDate', function (el, binding, vnode) {
    let data = binding.value;
    el.className = '';
    el.innerHTML = '';
    el.title = '';
    if (Number(data.stock) > 0 && Number(data.is_split_large) !== 1 && Number(data.expire_day) > 1 && Number(data.production_date) > 0) {
        let now = Math.round(new Date().getTime() / 1000);;
        // 计算过期时间
        let _time = Math.plus(data.production_date, Math.multiple(data.expire_day, 86400));
        // 过期时间 > 当前时间
        if (_time > now) {
            let diff = Math.minus(_time, now);
            let _day = Math.floor(Math.division(diff, 86400));
            if (_day < 10) {
                el.className = 'badge badge-pill badge-warning';
                el.innerHTML = _day;
                el.title = '该商品还有' + _day + '天过期';
            }
        } else {
            el.className = 'badge badge-pill badge-danger';
            el.innerHTML = '过';
            el.title = '该商品已过期';
        }   
    }
})

Vue.directive('checkStock', function (el, binding, vnode) {
    let data = binding.value;
    el.className = '';
    el.innerHTML = '';
    el.title = '';
    if (Number(data.is_split_large) !== 1) {
        let max = Number(data.max_stock);
        let min = Number(data.min_stock);
        let stock = Number(data.stock);
        // 当库存上限有设置的时候，才做判断
        if (max > 0) {
            if (stock > max) {
                el.className = 'badge badge-pill badge-warning';
                el.innerHTML = '多';
                el.title = '该商品库存(' + stock + ')超上限(' + max + ')了';
            } else if (stock > 0 && stock <= min) {
                el.className = 'badge badge-pill badge-warning';
                el.innerHTML = '少';
                el.title = '该商品库存仅剩' + stock + '件';
            } else if (stock <= 0) {
                el.className = 'badge badge-pill badge-danger';
                el.innerHTML = '罄';
                el.title = '该商品已售罄';
            }
        }
    }
})

Vue.directive('counter', function (el, binding) {
    let endVal = Number(binding.value);
    let nowVal = Number(el.innerHTML);
    if (endVal === nowVal) {
        el.innerHTML = endVal;
        return false;
    }
    let startVal = 0;
    let time = 3000;
    let _time = 100;
    let times = time / _time;
    let step  = Math.abs(Math.round(endVal / times));
    step = step < 1 ? 1 : step;
    function addNumber () {
        if (endVal >= 0) {
            startVal = Number(startVal) + Number(step);
        } else {
            startVal = Number(startVal) - Number(step);
        }
        startVal = Math.round(startVal);
        if (Math.abs(startVal) < Math.abs(endVal)) {
            el.innerHTML = startVal;
            setTimeout(() => {
                addNumber();
            }, _time)
        } else {
            el.innerHTML = endVal;
        }
    }
    addNumber();
})



// WEBPACK FOOTER //
// ./src/directives/index.js